export default __webpack_public_path__ + "static/media/dk4.8d00eddf.jpg";